import { createContext, useContext } from "react";

export interface UserData {
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface FeedbackOption {
  label: string;
  value: string;
}

export interface FeedbackOptionCategory {
  label: string;
  value: string;
  title: boolean;
  children: FeedbackOption[];
}

const OrderListFeedbackContext = createContext<{
  userData: UserData;
  orderFeedbackOptions: FeedbackOptionCategory[];
}>({ userData: { uid: "", firstName: "", lastName: "", phone: "", email: "" }, orderFeedbackOptions: [] });

export const OrderListFeedbackContextProvider = OrderListFeedbackContext.Provider;

export const useOrderListFeedback = () => useContext(OrderListFeedbackContext);
